import React from "react";
import { Flex, Input, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

function DefaultMessageInput({ defaultMessage, onChange }) {
  return (
    <div className="flex flex-col gap-2 w-full items-start" style={{ marginTop: "8px" }}>
      <Flex align="center" gap={6}>
        <label style={{ fontWeight: "bold", fontSize: "14px" }}>
          Default Travel Add-On Notice Message
        </label>
        <Tooltip title="This message will be shown when no specific rules match">
          <InfoCircleOutlined style={{ color: "#8c8c8c", fontSize: "14px" }} />
        </Tooltip>
      </Flex>
      <Typography.Text 
        type="secondary"
        style={{ 
          fontSize: "13px", 
          margin: 0,
          marginTop: "-4px",
          marginBottom: "4px"
        }}
      >
        This message will be displayed when no rules match the selected trade/service/job combination.
      </Typography.Text>
      <TextArea
        value={defaultMessage}
        onChange={onChange}
        placeholder="e.g., This location is outside our primary service area. Additional travel add-on may apply."
        rows={4}
        style={{ width: "100%" }}
        maxLength={200}
        showCount
      />
    </div>
  );
}

export default DefaultMessageInput;
